import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./modules/Auth/auth";
import sites from "./modules/Sites/sites";
import payments from "./modules/Payments/payments";
import client_catalog_groups from "./modules/ClientCatalogGroups/client_catalog_groups";
import common from "./modules/Common/common";
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    sites,
    client_catalog_groups,
    common,
    payments
  },
});